module.exports = __webpack_public_path__ + "static/img/General Advice.f519c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/General Advice.png
// module id = mOCc
// module chunks = 7